import { defineComponent } from 'vue'
import NumberHistoryChart from '@/components/number-history-chart'

export default defineComponent({
  name: 'SpecialHistoryPage',
  setup() {
    return () => <NumberHistoryChart type={2} />
  },
})
